import { TreeControl } from '@angular/cdk/tree';
import { Output, OnDestroy, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { SubSink } from 'subsink';

export class FilenetNestedTreeControl
    implements TreeControl<Folder>, OnDestroy {
    private subs = new SubSink();

    dataNodes: any[];
    expansionModel: import('@angular/cdk/collections').SelectionModel<any>;
    getLevel: (dataNode: any) => number;
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    collapseAll(): void {
        throw new Error('Method not implemented.');
    }
    toggleDescendants(dataNode: any): void {
        throw new Error('Method not implemented.');
    }
    expandDescendants(dataNode: any): void {
        throw new Error('Method not implemented.');
    }
    collapseDescendants(dataNode: any): void {
        throw new Error('Method not implemented.');
    }

    destroy() {
        this.ngOnDestroy();
    }

    constructor(
        private folderService: FolderService,
        private objectStore: string
    ) {
        // this.subs.add(
        //   this.folderService.selectExpandedFolderIds$
        //     .pipe(DebugObservable('FilenetNestedTreeControl.expandedFolders'))
        //     .subscribe(value => (this.expandedFolderIds = value))
        // );
    }

    private compareFolders(a: Folder, b: Folder): number {
        if (a.propertiesObj.FolderName === undefined) {
            return 1;
        }
        if (b.propertiesObj.FolderName === undefined) {
            return -1;
        }
        return a.propertiesObj.FolderName > b.propertiesObj.FolderName ? 1 : -1;
    }

    //   public getChildren:(node: Folder) => [];
    public getChildren(node: Folder): Observable<Folder[]> {
        if (node && (!node.subFolders || node.subFolders.length === 0)) {
            return of([]);
        }

        return this.folderService
            .displayByIds(node.subFolders)
            .pipe(map(v => v.sort((a, b) => this.compareFolders(a, b))));
    }

    expandedIds = [];

    isExpanded(node: Folder) {
        return node && this.expandedIds.indexOf(node.id) >= 0;
    }

    isExpandable(node: Folder) {
        return node && node.subFolders && node.subFolders.length > 0;
    }

    toggle(node: Folder) {
        if (this.isExpanded(node)) {
            this.collapse(node);
        } else {
            this.expand(node);
        }
    }

    addExpandedId(id: string) {
        if (!(this.expandedIds.indexOf(id) >= 0)) {
            // console.log('Adding expanded parent', id);
            this.expandedIds.push(id);

            this.folderService
                .getByID(this.objectStore, id)
                .pipe(
                    switchMap(v =>
                        this.folderService.getByIds(
                            this.objectStore,
                            v.subFolders
                        )
                    ),
                    take(1)
                )
                .subscribe(v => {
                    // console.log("Got Parent", v);
                    // this.changed.emit(v);
                    return;
                });

            // console.log(this.expandedIds);
        }
    }

    expand(node: Folder) {
        this.folderService
            .getByIds(this.objectStore, node.subFolders)
            .pipe(take(1))
            .subscribe(v => {
                // this.changed.emit(v);
                return;
            });

        this.expandedIds.push(node.id, this.expandedIds);
    }

    collapse(node: Folder) {
        this.expandedIds = this.expandedIds.filter(v => v !== node.id);
    }

    expandAll(): void {
        throw new Error('Method not implemented.');
    }

    getDescendants(dataNode: Folder): Folder[] {
        throw new Error('Method not implemented.');
    }
}
